<template>
  <ChartPie :options="chartOptions" :data="chartData" :style="styles" />
</template>

<script>
import { Pie as ChartPie } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, ArcElement);

const PALETTE = [
  "#114d8c",
  "#28a745",
  "#ffc107",
  "#dc3545",
  "#6f42c1",
  "#17a2b8",
  "#fd7e14",
  "#6c757d",
];

export default {
  name: "PieChart",
  props: ["chartData", "styles"],
  components: { ChartPie },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: "bottom" },
        },
      },
    };
  },
  methods: {
    defaultColors(count) {
      return Array.from({ length: count }, (_, i) => PALETTE[i % PALETTE.length]);
    },
  },
};
</script>
